function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  width: "90",
  height: "67",
  viewBox: "0 0 105 78",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("path", {
  d: "M7.025 38.99a.5.5 0 11-1 0 .5.5 0 011 0z",
  fill: "#A0F",
  stroke: "url(#svg3360936829__paint0_linear)"
}), React.createElement("path", {
  d: "M16.975 66.88a.5.5 0 11-1 0 .5.5 0 011 0z",
  fill: "#A0F",
  stroke: "url(#svg3360936829__paint1_linear)"
}), React.createElement("path", {
  d: "M37.975 76.49a.5.5 0 11-1 0 .5.5 0 011 0z",
  fill: "#A0F",
  stroke: "url(#svg3360936829__paint2_linear)"
}), React.createElement("path", {
  d: "M37.975 1.51a.5.5 0 11-1 0 .5.5 0 011 0z",
  fill: "#A0F",
  stroke: "url(#svg3360936829__paint3_linear)"
}), React.createElement("path", {
  d: "M23.975 58.99a.5.5 0 11-1 0 .5.5 0 011 0z",
  fill: "#A0F",
  stroke: "url(#svg3360936829__paint4_linear)"
}), React.createElement("path", {
  d: "M10.935 6.41a.5.5 0 11-1 0 .5.5 0 011 0z",
  fill: "#A0F",
  stroke: "url(#svg3360936829__paint5_linear)"
}), React.createElement("path", {
  d: "M17.935 14.31a.5.5 0 11-1 0 .5.5 0 011 0z",
  fill: "#A0F",
  stroke: "url(#svg3360936829__paint6_linear)"
}), React.createElement("path", {
  d: "M2.025 38.99a.5.5 0 11-1 0 .5.5 0 011 0z",
  fill: "#A0F",
  stroke: "url(#svg3360936829__paint7_linear)"
}), React.createElement("path", {
  d: "M83.335 30.3c-28.5-3.34-39.5-16.08-44.85-25.82m46.1 30.56c-42.92-1.93-58.29-11.27-64.42-17.55m64.84 21.53l-72.53-.03m70.72 9.1c-25.51 3.07-36.84 13.7-42.96 22.9m44.28-27.37c-32.03 1.5-48.33 7.05-57.54 12.44m57.75-4.69c6.91-14.72-.49-24.7-.49-24.7h14.58c4.49 1.42 4.66 12.32 4.66 12.32.06 9.33-4.08 12.35-4.08 12.35l-14.67.03z",
  stroke: "url(#svg3360936829__paint8_linear)",
  strokeWidth: "1.5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("defs", null, React.createElement("linearGradient", {
  id: "svg3360936829__paint0_linear",
  x1: "6.525",
  y1: "37.99",
  x2: "6.525",
  y2: "39.99",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#A0F"
}), React.createElement("stop", {
  offset: "1",
  stopColor: "#00A3D7"
})), React.createElement("linearGradient", {
  id: "svg3360936829__paint1_linear",
  x1: "16.475",
  y1: "65.88",
  x2: "16.475",
  y2: "67.88",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#A0F"
}), React.createElement("stop", {
  offset: "1",
  stopColor: "#00A3D7"
})), React.createElement("linearGradient", {
  id: "svg3360936829__paint2_linear",
  x1: "37.475",
  y1: "75.49",
  x2: "37.475",
  y2: "77.49",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#A0F"
}), React.createElement("stop", {
  offset: "1",
  stopColor: "#00A3D7"
})), React.createElement("linearGradient", {
  id: "svg3360936829__paint3_linear",
  x1: "37.475",
  y1: ".51",
  x2: "37.475",
  y2: "2.51",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#A0F"
}), React.createElement("stop", {
  offset: "1",
  stopColor: "#00A3D7"
})), React.createElement("linearGradient", {
  id: "svg3360936829__paint4_linear",
  x1: "23.475",
  y1: "57.99",
  x2: "23.475",
  y2: "59.99",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#A0F"
}), React.createElement("stop", {
  offset: "1",
  stopColor: "#00A3D7"
})), React.createElement("linearGradient", {
  id: "svg3360936829__paint5_linear",
  x1: "10.435",
  y1: "5.41",
  x2: "10.435",
  y2: "7.41",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#A0F"
}), React.createElement("stop", {
  offset: "1",
  stopColor: "#00A3D7"
})), React.createElement("linearGradient", {
  id: "svg3360936829__paint6_linear",
  x1: "17.435",
  y1: "13.31",
  x2: "17.435",
  y2: "15.31",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#A0F"
}), React.createElement("stop", {
  offset: "1",
  stopColor: "#00A3D7"
})), React.createElement("linearGradient", {
  id: "svg3360936829__paint7_linear",
  x1: "1.525",
  y1: "37.99",
  x2: "1.525",
  y2: "39.99",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#A0F"
}), React.createElement("stop", {
  offset: "1",
  stopColor: "#00A3D7"
})), React.createElement("linearGradient", {
  id: "svg3360936829__paint8_linear",
  x1: "57.975",
  y1: "4.479",
  x2: "57.975",
  y2: "70.99",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#A0F"
}), React.createElement("stop", {
  offset: "1",
  stopColor: "#00A3D7"
})))));